import { render, staticRenderFns } from "./KlafsLogo.vue?vue&type=template&id=78ddce84&scoped=true&"
var script = {}
import style0 from "./KlafsLogo.vue?vue&type=style&index=0&id=78ddce84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ddce84",
  null
  
)

export default component.exports